module.exports = __webpack_public_path__ + "img/1557614068566663170.924d3700.png";